<div class="info-item-template">
  <ng-content></ng-content>
</div>